import { ArrowsLeftRight, Storefront, LockKey, UsersThree, GridFour, Code } from "@phosphor-icons/react";
import { useSiteConfig } from "@/hooks/useSiteConfig";
import { Reveal, SectionHeader, StatusChip } from "./primitives";

const ICONS = { ArrowLeftRight: ArrowsLeftRight, Storefront, LockKey, Votes: UsersThree, GridFour, Code };

const Utility = () => {
  const config = useSiteConfig();
  return (
    <section id="utility" className="relative py-24 lg:py-36 border-t border-line" data-testid="utility-section">
      <div className="section-shell">
        <SectionHeader
          index={6}
          eyebrow="Utility"
          title={<>Utility That Goes<br />Beyond the Token</>}
          sub="JCV is designed to become the native digital asset supporting the broader Jovino ecosystem. Current and planned functionality is clearly labelled."
          testId="utility-header"
        />
        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {config.utilities.map((u, i) => {
            const Icon = ICONS[u.icon] || GridFour;
            const live = u.tone === "teal";
            return (
              <Reveal key={u.title} delay={i * 0.07} testId={`utility-card-${i}`}>
                <article
                  className={`card-surface group h-full rounded-xl p-8 ${live ? "" : "opacity-90"}`}
                >
                  <div className="flex items-start justify-between gap-4">
                    <Icon size={28} className={`${live ? "text-teal" : "text-slate"} transition-transform duration-300 group-hover:scale-110`} aria-hidden="true" />
                    <StatusChip tone={live ? "teal" : "slate"} testId={`utility-status-${i}`}>{u.status}</StatusChip>
                  </div>
                  <h3 className="mt-6 font-display text-lg lg:text-xl font-semibold text-mist">{u.title}</h3>
                  <p className="mt-3 text-sm text-slate leading-relaxed">{u.body}</p>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Utility;
